import { render } from "./SelectionComponent.vue?vue&type=template&id=c182ae9c&scoped=true"
import script from "./SelectionComponent.vue?vue&type=script&lang=js"
export * from "./SelectionComponent.vue?vue&type=script&lang=js"

import "./SelectionComponent.vue?vue&type=style&index=0&id=c182ae9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c182ae9c"]])

export default __exports__